export default __webpack_public_path__ + "static/media/courses4.5e16ef9e.svg";